import { Box, useTheme } from "@mui/material";
import { useEffect, useRef } from "react";

interface EmailViewerProps {
  body: string;
  height?: number;
  onChange?: (value: string) => void;
}

function EmailEditer({ body, height = 500, onChange }: EmailViewerProps) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const theme = useTheme(); // ✅ detect MUI theme (light/dark)

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const doc = iframe.contentDocument;
    if (!doc) return;
    const customCSS = `
      body {
        font-family: ${theme.typography.fontFamily};
        font-size: 14px;
        margin: 8px;
        color:${theme.palette.text.primary} !important;
      }
      .elementToProof {
          color:${theme.palette.text.primary} !important;
      }
    `;

    // write content
    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <style>${customCSS}</style>
        </head>
        <body>${body || "<p></p>"}</body>
      </html>
    `);
    doc.close();

    // make editable
    if (doc.body) {
      doc.body.contentEditable = "true";

      const handleInput = () => {
        if (onChange) {
          const updatedHTML = doc.body.innerHTML;
          onChange(updatedHTML);
        }
      };

      doc.body.addEventListener("input", handleInput);

      return () => {
        doc.body?.removeEventListener("input", handleInput);
      };
    }
  }, [body, theme]); // rerun on theme change

  return (
    <Box>
      <iframe
        ref={iframeRef}
        width="100%"
        height={height}
        title="Editable Email Preview"
        style={{
          border: `1px solid ${theme.palette.divider}`,
          color: theme.palette.text.primary,
          borderRadius: "8px",// ✅ apply outer background
        }}
      />
    </Box>
  );
}

export default EmailEditer;
